export enum DepreciationStartType {
NextMonth,
PurchaseDate,
}
